import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props, d as defaults } from './componentEl-c8b73b10.js';
import { B as Box } from './Box-17ae6268.js';
import { I as Illustration } from './Illustration-19b58cb7.js';
import { B as Button } from './Button-7604c54d.js';

/**
Login component
*/
function Login({
  name,
  illustration,
  ...otherProps
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "st_login"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: {
      all: 'mlg'
    },
    className: "st_login__box"
  }, illustration && /*#__PURE__*/React.createElement(Illustration, {
    className: "st_login__illustration",
    name: illustration
  }), /*#__PURE__*/React.createElement("h1", {
    className: "st_login__name"
  }, name), /*#__PURE__*/React.createElement("p", {
    className: "st_login__text"
  }, "Please click login to continue"), /*#__PURE__*/React.createElement(Button, _extends({
    primary: true,
    fullWidth: true
  }, otherProps), "Login")));
}
Login.propTypes = {
  /** dom element for the BUTTON */
  componentEl: props,
  /** name of app */
  name: PropTypes.string.isRequired,
  /** name of illustraton to show */
  illustration: PropTypes.string,
  /** click handler for the BUTTON */
  onClick: PropTypes.func.isRequired
};
Login.defaultProps = {
  componentEl: defaults,
  illustration: null
};

export { Login as L };
